var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useRef } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import VehicleList from '../VehicleList';
import FilterDropdown from '../../FilterDropdown';
import FilterResult from '../../FilterResult';
import ToggleFilter from '../../ToggleFilter';
import style from './index.module.scss';
import instance from '../../../services/httpRequest';
import analyseData from '../../../utils/analyseData';
import Loading from '../../Loading';
import localesReplacement from '../../../utils/localesReplacement';
var cx = classnames.bind(style);
var classDropdownItem = 'dropdown-item';
function VehicleSearch(props) {
    var replacements = props.replacements, onVehicleSelect = props.onVehicleSelect, categoriesType = props.categoriesType, selectedWorkshop = props.selectedWorkshop, restore = props.restore, preserved = props.preserved;
    var _a = useState(), vehicleTypes = _a[0], setVehicleTypes = _a[1];
    var _b = useState(), typeID = _b[0], setTypeID = _b[1];
    var _c = useState([]), makes = _c[0], setMakes = _c[1];
    var _d = useState(''), make = _d[0], setMake = _d[1];
    var _e = useState([]), models = _e[0], setModels = _e[1];
    var _f = useState(''), model = _f[0], setModel = _f[1];
    var _g = useState(''), year = _g[0], setYear = _g[1];
    var _h = useState([]), vehicles = _h[0], setVehicles = _h[1];
    var _j = useState(true), filterVisible = _j[0], setFilterVisible = _j[1];
    var _k = useState(false), isMount = _k[0], setIsMount = _k[1];
    var type = _.chain(vehicleTypes).find(['id', typeID]).get('name').value();
    var controller = new AbortController();
    var memoDate = useCallback(function () {
        setIsMount(true);
        selectedWorkshop
            ? _.assign(instance.defaults.headers, { isWorkshopOwner: selectedWorkshop })
            : _.unset(instance.defaults.headers, 'isWorkshopOwner');
        instance
            .get('/categories', { signal: controller.signal })
            .then(function (d) {
            var _a, _b;
            setVehicleTypes(d.data);
            sessionStorage.getItem('searchTypeId')
                ? setTypeID((_a = sessionStorage.getItem('searchTypeId')) !== null && _a !== void 0 ? _a : '')
                : setTypeID((_b = d.data[0]) === null || _b === void 0 ? void 0 : _b.id);
        })
            .then(function () { return setIsMount(false); }).catch(function (error) {
            window.dataLayer.push({
                'event': 'detailsUnavailable_vehicleSearches',
                'pageType': 'product finder',
                'searchType': 'vehicle search',
                'userType': sessionStorage.getItem('selectedType') === 'true' ? 'workshop owner' : 'vehicle owner',
                'countryCode': localStorage.getItem('countryCode')
            });
        });
    }, [selectedWorkshop]);
    useEffect(function () {
        return function () {
            controller.abort();
        };
    }, []);
    useEffect(function () {
        var isMounted = true;
        typeID &&
            instance
                .get("/makes?categoryId=".concat(typeID), { signal: controller.signal })
                .then(function (d) {
                isMounted && setMakes(d.data);
                isMounted && setIsMount(false);
            });
        return function () {
            isMounted = false;
        };
    }, [typeID]);
    useEffect(function () {
        make &&
            instance
                .get("/models?makeId=".concat(_.chain(_.map(makes))
                .find(['name', make])
                .get('id')), { signal: controller.signal })
                .then(function (d) { return setModels(d.data); });
    }, [make]);
    useEffect(function () {
        model &&
            instance
                .get("/vehicleSearch?modelId=".concat(_.chain(models)
                .map(function (m) {
                var _a;
                var $modal = m['model'];
                var $yearFrom = m['yearFrom'];
                var $yearTo = (_a = m['yearTo']) !== null && _a !== void 0 ? _a : '';
                return (__assign(__assign({}, m), { model: "".concat($modal, " (").concat($yearFrom, " - ").concat($yearTo, ")") }));
            })
                .find(['model', model])
                .get('id')), { signal: controller.signal })
                .then(function (d) { return setVehicles(d.data); });
    }, [model]);
    var changeVehicleType = function (id) {
        setTypeID(id);
        setMakes([]);
        setMake('');
        setModels([]);
        setModel('');
        setVehicles([]);
        setYear('');
        restore && sessionStorage.setItem('searchTypeId', _.toString(id));
        restore && sessionStorage.removeItem('searchMake');
        restore && sessionStorage.removeItem('searchModel');
        restore && sessionStorage.removeItem('searchYear');
    };
    var changeMake = function (make) {
        setMake(make);
        setModels([]);
        setModel('');
        setVehicles([]);
        setYear('');
        restore && sessionStorage.setItem('searchMake', make);
        restore && sessionStorage.removeItem('searchModel');
        restore && sessionStorage.removeItem('searchYear');
    };
    var window = globalThis;
    window.dataLayer = window.dataLayer || [];
    var changeModel = function (model) {
        var vehicletype = vehicleTypes === null || vehicleTypes === void 0 ? void 0 : vehicleTypes.find(function (d) { return d.id === typeID; });
        setModel(model);
        setVehicles([]);
        setYear('');
        restore && sessionStorage.setItem('searchModel', model);
        restore && sessionStorage.removeItem('searchYear');
        window.dataLayer.push({
            'event': 'vehicleSearches',
            'pageType': 'product finder',
            'searchType': 'vehicle search',
            'userType': selectedWorkshop ? 'workshop owner' : 'vehicle owner',
            'vehicleCategory': vehicletype === null || vehicletype === void 0 ? void 0 : vehicletype.name,
            'vehicleMake': make,
            'vehicleModel': model,
            'countryCode': localStorage.getItem('countryCode')
        });
    };
    var preservedRef = useRef();
    useEffect(function () {
        memoDate();
        if (!preserved || _.isEqual(preservedRef.current, preserved)) {
            setMakes([]);
            setMake('');
            setModels([]);
            setModel('');
            setVehicles([]);
            setYear('');
            restore && sessionStorage.removeItem('searchTypeId');
            restore && sessionStorage.removeItem('searchMake');
            restore && sessionStorage.removeItem('searchModel');
            restore && sessionStorage.removeItem('searchYear');
        }
        preservedRef.current = preserved;
    }, [selectedWorkshop, preserved]);
    useEffect(function () {
        var _a;
        if (preserved) {
            sessionStorage.getItem('searchTypeId') &&
                setTypeID((_a = _.toNumber(sessionStorage.getItem('searchTypeId'))) !== null && _a !== void 0 ? _a : undefined);
        }
    }, [preserved]);
    useEffect(function () {
        var _a;
        if (preserved && !_.isEmpty(makes)) {
            sessionStorage.getItem('searchMake') &&
                setMake((_a = sessionStorage.getItem('searchMake')) !== null && _a !== void 0 ? _a : '');
        }
    }, [preserved, makes]);
    useEffect(function () {
        var _a;
        if (preserved && !_.isEmpty(models)) {
            sessionStorage.getItem('searchModel') &&
                setModel((_a = sessionStorage.getItem('searchModel')) !== null && _a !== void 0 ? _a : '');
        }
    }, [preserved, models]);
    useEffect(function () {
        var _a;
        if (preserved && !_.isEmpty(vehicles)) {
            sessionStorage.getItem('searchYear') &&
                setYear((_a = sessionStorage.getItem('searchYear')) !== null && _a !== void 0 ? _a : '');
        }
    }, [preserved, vehicles]);
    return (_jsx(_Fragment, { children: !isMount ? (_jsxs(_Fragment, { children: [!!vehicleTypes && !!typeID && (_jsxs(_Fragment, { children: [_jsx(VehicleList, { dataList: vehicleTypes, selected: typeID, changeVehicleTypeHandler: changeVehicleType, categoriesType: categoriesType }, void 0), _jsxs("div", __assign({ className: cx('dropdown-list') }, { children: [_jsx("div", __assign({ className: cx(classDropdownItem) }, { children: _jsx(FilterDropdown, { dataList: makes, filter: make, changeHandler: changeMake, type: localesReplacement(replacements, 'Make'), replacements: replacements }, void 0) }), void 0), _jsx("div", __assign({ className: cx(classDropdownItem) }, { children: _jsx(FilterDropdown, { dataList: _.chain(models)
                                            .map(function (d) { return ({
                                            id: d['id'],
                                            name: d['model'],
                                            yearFrom: d['yearFrom'],
                                            yearTo: d['yearTo'],
                                        }); })
                                            .uniqBy(function (elem) { return [elem.yearFrom, elem.yearTo, elem.name].join(); })
                                            .map(function (m) {
                                            var _a;
                                            return m['name'] +
                                                " (".concat(m['yearFrom'], " - ").concat((_a = m['yearTo']) !== null && _a !== void 0 ? _a : '', ")");
                                        })
                                            .value(), filter: model, changeHandler: changeModel, type: localesReplacement(replacements, 'Model'), replacements: replacements }, void 0) }), void 0), _jsx(ToggleFilter, { toggleHandler: setFilterVisible, panelVisible: filterVisible }, void 0), _jsx("div", __assign({ className: cx(classDropdownItem, { hidden: !filterVisible }) }, { children: _jsx(FilterDropdown, { dataList: analyseData.year(vehicles), filter: year, changeHandler: function (v) {
                                            setYear(v);
                                            sessionStorage.setItem('searchYear', v);
                                        }, type: localesReplacement(replacements, 'Year'), replacements: replacements }, void 0) }), void 0)] }), void 0)] }, void 0)), !!vehicles && type && make && model && (_jsx(FilterResult, { dataList: _.map(vehicles, function (d) { return (__assign(__assign({}, d), { vehicleType: type, make: make, model: model })); }), vehicleType: type, make: make, model: model, year: year, onSelect: onVehicleSelect, replacements: replacements }, void 0))] }, void 0)) : (_jsx(Loading, {}, void 0)) }, void 0));
}
export default VehicleSearch;
